import React from 'react';
import './css/footer.css';

class Footer extends React.Component {
  
  render() {
    return (
        <footer>
          <hr/>
          <span className="copyright">&copy; 2016-2018 toby weston</span>
        </footer>
    )
  }

}

export default Footer;


// WEBPACK FOOTER //
// ./src/Footer.js